import { Component, inject } from '@angular/core';
import { SidebarItemV2 } from '../sidebar-item-v2/sidebar-item-v2';
import { ArchiveTickOutline } from '../../../shared/components/icons/archive-tick-outline';
import { BookOutline } from '../../../shared/components/icons/book-outline';
import { CalendarOutline } from '../../../shared/components/icons/calendar-outline';
import { FolderOutline } from '../../../shared/components/icons/folder-outline';
import { LogoutOutline } from '../../../shared/components/icons/logout-outline';
import { MedalStarOutline } from '../../../shared/components/icons/medal-star-outline';
import { ProfileCircleOutline } from '../../../shared/components/icons/profile-circle-outline';
import { SettingTwoOutline } from '../../../shared/components/icons/setting-two-outline';
import { ShoppingBagOutline } from '../../../shared/components/icons/shopping-bag-outline';
import { LOCAL_ROUTES } from '../../../core/constants/local-routes.constants';
import { AuthState } from '../../../features/auth/services/auth.state';

@Component({
  selector: 'sidebar-v2',
  imports: [SidebarItemV2],
  templateUrl: './sidebar-v2.html',
  styleUrl: './sidebar-v2.scss',
})
export class SidebarV2 {
  private authState = inject(AuthState);

  ArchiveTickOutline = ArchiveTickOutline;
  BookOutline = BookOutline;
  CalendarOutline = CalendarOutline;
  FolderOutline = FolderOutline;
  LogoutOutline = LogoutOutline;
  MedalStarOutline = MedalStarOutline;
  ProfileCircleOutline = ProfileCircleOutline;
  SettingTwoOutline = SettingTwoOutline;
  ShoppingBagOutline = ShoppingBagOutline;

  routes = LOCAL_ROUTES;

  logout() {
    this.authState.logout();
  }
}
